module.exports = __webpack_public_path__ + "static/post-three-34421992f100c4896f9ad1b48841fd61.png";